import React from 'react';
import { Grid, Typography } from '@mui/material';
import * as yup from 'yup';
import { SparkForm, SparkTextField } from 'sharedComponents/SparkForm';
import Footer from 'components/AuthScreens/Register/Stepper/Footer';

export type CreatorProfessionalInfoFormValues = {
  description: string;
  website: string;
  linkedin: string;
  twitter: string;
  youtube: string;
  facebook: string;
  x: string;
};

type CreatorProfessionalInfoFormProps = {
  activeStep: number;
  nextStepHandler: () => void;
  previousStepHandler: () => void;
  professionalInfoCollection?: CreatorProfessionalInfoFormValues;
  setProfessionalInfoCollection: (
    formValues: CreatorProfessionalInfoFormValues
  ) => void;
};

function CreatorProfessionalInfoForm({
  activeStep,
  nextStepHandler,
  previousStepHandler,
  professionalInfoCollection,
  setProfessionalInfoCollection,
}: CreatorProfessionalInfoFormProps) {
  const initialValues = {
    description: '',
    website: '',
    linkedin: '',
    twitter: '',
    youtube: '',
    facebook: '',
    x: '',
  };
  const validationSchema = yup.object().shape({
    description: yup.string().required('Required').max(500),
  });

  const handleSubmit = async (values: CreatorProfessionalInfoFormValues) => {
    setProfessionalInfoCollection(values);
    nextStepHandler();
  };
  return (
    <SparkForm
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSave={handleSubmit}
    >
      <Grid item xs={12}>
        <Typography variant='h5' fontFamily='Mont-semibold' pt={2}>
          Professional Info
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant='body1' pb={2}>
          Let potential buyers know what you do best and how you gained your
          skills.
        </Typography>
      </Grid>
      <SparkTextField
        name='description'
        label='Description'
        placeholder='Share a bit about your work experience, cool projects you’ve completed and your area of expertise.'
        size={12}
        multiline={true}
        rows={3}
        showCounter={true}
        maxNumber={500}
        helpText='your work experience, cool projects you’ve completed and your area of expertise.'
      />
      <Grid item xs={12}>
        <Typography variant='body1' fontFamily='Mont-semibold' pb={2}>
          Links
        </Typography>
      </Grid>
      <SparkTextField
        name='website'
        label=''
        placeholder='Website'
        size={12}
        socialMediaIcon='website'
      />
      <SparkTextField
        name='linkedin'
        label=''
        placeholder='Linkedin'
        size={12}
        socialMediaIcon='linkedin'
      />

      <SparkTextField
        name='twitter'
        label=''
        placeholder='Twitter'
        size={12}
        socialMediaIcon='twitter'
      />
      <SparkTextField
        name='youtube'
        label=''
        placeholder='YouTube'
        size={12}
        socialMediaIcon='youtube'
      />
      <SparkTextField
        name='facebook'
        label=''
        placeholder='Facebook'
        size={12}
        socialMediaIcon='facebook'
      />

      <Footer
        activeStep={activeStep}
        handleBack={previousStepHandler}
        isLastStep={false}
      />
    </SparkForm>
  );
}

export default CreatorProfessionalInfoForm;
